<template>
  <!-- <a-alert message="Informational" description="Our Dashboard is Coming Soon" type="info" showIcon /> -->
   <a-card style="display:none">
    <div slot="title">
      Proyeksi Laba Rugi Kotor {{ year }}
    </div>
    <a-table :columns="columns" :data-source="datasource" bordered size="small" :loading="loading.table"
    :rowKey="(record, index) => { return index; }"
    >
      <template slot="cost_center_nm" slot-scope="item">
        <div style="text-align: left!important;">{{ item.cost_center_nm }}</div>
      </template>
      <template slot="pendapatan" slot-scope="item">
        <div style="text-align: right!important;">{{ formatCurrency('IDR',Number(item.pendapatan)) }}</div>
      </template>
      <template slot="komisi" slot-scope="item">
        <div style="text-align: right!important;">{{ formatCurrency('IDR',Number(item.komisi)) }}</div>
      </template>
      <template slot="biaya_langsung" slot-scope="item">
        <div style="text-align: right!important;">{{ formatCurrency('IDR',Number(item.biaya_langsung)) }}</div>
      </template>
      <template slot="laba_kotor" slot-scope="item">
        <div style="text-align: right!important;">{{ formatCurrency('IDR',Number(item.laba_kotor)) }}</div>
      </template>
    </a-table>
   </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  name: "FinancialControlBoard",
  mixins: [GlobalMethod, CurrencyFormat],
  computed: {
    ...mapGetters(["getAuth","getScreen"])
  },
  data(){
    const columns = [
      {
        title: 'Proyek',
        key: 'cost_center_nm',
        align:'center',
        scopedSlots: { customRender: "cost_center_nm" }
      },
      {
        title: 'Pendapatan',
        key: 'pendapatan',
        align:'center',
        scopedSlots: { customRender: "pendapatan" }
      },
      {
        title: 'Komisi',
        align:'center',
        key: 'komisi',
        scopedSlots: { customRender: "komisi" }
      },
      {
        title: 'Biaya Langsung',
        align:'center',
        key: 'biaya_langsung',
        scopedSlots: { customRender: "biaya_langsung" }
      },
      {
        title: 'Laba Kotor',
        align:'center',
        key: 'laba_kotor',
        scopedSlots: { customRender: "laba_kotor" }
      },
    ];

    return {
      columns,
      year: moment().format('YYYY'),
      datasource: [],
      loading:{
        table : false
      }
    }
  },
  mounted(){
    this.fetchData()
  },
  methods: {
    moment,
    async fetchData(){
      this.loading.table = true
      await this.asyncAxiosGet("dashboard/proyeksi_laba_rugi_kotor",
        this.getAuth,
        {
          year: this.year,
        }
      ).then((res) => {
        this.datasource = res.data
        this.loading.table = false
      })
    }
  }
};
</script>